import { createContext } from "react";

import { CollapsibleSectionContextType } from "./types";

export const CollapsibleSectionContext = createContext<CollapsibleSectionContextType | undefined>(
  undefined
);
